<template>
  <div class="continer">
    <baidu-map id="allmap" :scroll-wheel-zoom="true" @ready="mapReady"></baidu-map>
  </div>
</template>
<script>
export default {
  data() {
    return {
      point: "",
    };
  },
  methods: {
    mapReady({ BMap, map }) {
      // 选择一个经纬度作为中心点
      this.point = new BMap.Point(122.289808, 43.630923);
      map.centerAndZoom(this.point, 28);
      var marker = new BMap.Marker(this.point)  // 创建标注
      map.addOverlay(marker);              // 将标注添加到地图中
      var opts = {
        width : 200,     // 信息窗口宽度
        height: 50,     // 信息窗口高度
        // title : "海底捞王府井店" , // 信息窗口标题
      }
      var infoWindow = new BMap.InfoWindow("通辽大地建设工程施工图审查有限责任公司  地址:霍林河大街1380号", opts);  // 创建信息窗口对象 
      marker.addEventListener("click", function(){          
        map.openInfoWindow(infoWindow,this.point); //开启信息窗口
      });
    },
    
  },
};
</script>
<style lang="stylus" scoped>

.continer {
  width: 100%;
  color: #333;

  /* 设定地图的大小 */
  #allmap {
    height: 800px;
    width: 920px;
    margin: 0 auto;
  }
  
}

</style>
